<script lang="ts" setup>
import { User } from "~/types";
import { ElNotification } from "element-plus";
import { onMounted } from "vue";
import CallService from "~/projects/cc/services/CallService";
import { useDialogStore } from "~/projects/cc/stores/dialogStore";

const callService = inject("callService") as CallService;
const dialogStore = useDialogStore();

onMounted(async () => {});

const handleCancel = function () {
  dialogStore.setTransferCallModalVisibility(false);
};

const initiateCallTransfer = function (agent: User) {
  console.log(agent);
  if (agent === null) return;

  callService.transferCall(agent).then(({ error }) => {
    if (error) {
      console.log(error);
      ElNotification({
        title: "Error",
        message: "Call Transfer Failed",
        type: "error",
      });
      return;
    }
    ElNotification({
      title: "Success",
      message: "Call Transfer Initiated",
      type: "success",
    });
    dialogStore.setTransferCallModalVisibility(false);
  });
};
</script>

<template>
  <el-dialog
    v-model="dialogStore._showTransferCallModal"
    title="Warning"
    width="35%"
    show-close="false"
    center
  >
    <template #header>Transfer Call</template>
    <div class="space-y-2">
      <div class="max-h-96 overflow-y-auto space-y-2 pr-2">
        <el-empty
          v-if="!dialogStore.transferableAgents?.length"
          description="No available agents"
          image-size="120"
        />
        <div
          v-for="agent in dialogStore.transferableAgents"
          v-else
          :key="agent.id"
          class="flex items-center justify-between p-3 border rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
        >
          <div class="flex-1">
            <div class="font-semibold text-sm">{{ agent.name }}</div>
            <div class="text-xs text-gray-500 mt-1">
              <span v-if="(agent as any).queue" class="inline-block">
                Queue: {{ (agent as any).queue }}
              </span>
              <span v-else class="text-gray-400 italic">No queue</span>
            </div>
          </div>
          <PrimaryActionBtn
            class="rounded px-3 py-1.5 bg-green-700 text-white hover:bg-green-800 transition-colors text-sm"
            @click="initiateCallTransfer(agent)"
          >
            Transfer
          </PrimaryActionBtn>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<style scoped></style>
